import {
  Box,
  Button,
  Flex,
  Icon,
  Image,
  Link,
  Text,
  Tooltip,
  Badge,
  useColorModeValue,
  IconButton,
  useClipboard,
  Input,
  InputGroup,
  ButtonGroup,
  Menu,
  MenuButton,
  MenuList,
  MenuItem,
  MenuItemOption,
  MenuGroup,
  MenuOptionGroup,
  MenuIcon,
  MenuCommand,
  MenuDivider,
} from "@chakra-ui/react";
import {
  MdBlockFlipped,
  MdContentCopy,
  MdEdit,
  MdOutlineKeyboardArrowDown,
} from "react-icons/md";

import Amazon from "assets/img/amazon.ico";
import Flipkart from "assets/img/flipkart.ico";
import Snapdeal from "assets/img/snapdeal.ico";
import Meesho from "assets/img/meesho.ico";
import Glowroad from "assets/img/glowroad.ico";
import Shopsy from "assets/img/shopsy.ico";
import freeup from "assets/img/freeup.ico";

import Card from "components/card/Card.js";

import React, { useState, useRef } from "react";

export default function ProductCard({
  index,
  rowId,
  details,
  report,
  invoice,
  fetchProducts,
  handleSuccessAlert,
  handleFailureAlert,
  isAdmin
}) {
  const backendUrl = process.env.REACT_APP_BACKEND_URL;
  const userInfo = JSON.parse(localStorage.getItem("PAuser"));
  const reportRef = useRef(null);
  const invoiceRef = useRef(null);
  const testProduct = details;
  const textColor = useColorModeValue("navy.700", "white");
  const bgItem = useColorModeValue(
    { bg: "white", boxShadow: "0px 40px 58px -20px rgba(112, 144, 176, 0.12)" },
    { bg: "navy.700", boxShadow: "unset" }
  );
  const { hasCopied, onCopy } = useClipboard(details.prod_code);
  const [showSubmit, setShowSubmit] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [uploadReport, setReport] = useState([]);
  const [uploadInvoice, setInvoice] = useState([]);

  const getPlatformIcon = (platformId) => {
    switch (platformId) {
      case 1:
        return Amazon;
      case 2:
        return Flipkart;
      case 3:
        return Snapdeal;
      case 4:
        return Meesho;
      case 5:
        return Glowroad;
      case 6:
        return Shopsy;
      case 7:
        return freeup;
      default:
        return null;
    }
  };

  const refs = {
    invoice: invoiceRef,
    report: reportRef,
  };

  const handleButtonClick = (type) => {
    refs[type].current.click();
  };

  const handleFileChange = (e) => {
    const { name, files } = e.target;
    if (name === "report") {
      setReport(Array.from(files));
    } else if (name === "invoice") {
      setInvoice(files[0]);
    }
    setShowSubmit(true);
  };

  const handleSubmit = async () => {
    try {
      setSubmitting(true);
      const formDataToSend = new FormData();

      formDataToSend.append("rowId", rowId);

      if (uploadReport) {
        uploadReport.forEach((file, idx) => {
          formDataToSend.append(`report${idx + 1}`, file);
        });
      }
      if (uploadInvoice) {
        formDataToSend.append("invoice", uploadInvoice);
      }

      formDataToSend.append("uid", userInfo?.message?.result.id);

      console.log(formDataToSend);
      const response = await fetch(`${backendUrl}/api/test/addFiles`, {
        method: "POST",
        body: formDataToSend,
      });

      const json = await response.json();

      if (!response.ok) {
        console.log(`Error saving changes: ${json.message || "Unknown error"}`);
        return;
      }
      handleSuccessAlert("Files Uploaded successfully.");
    } catch (e) {
      console.log("Error saving changes. Please try again");
      handleFailureAlert("File upload unsuccessful.");
    } finally {
      fetchProducts(userInfo?.message?.result.id);
      setSubmitting(false);
      setShowSubmit(false);
      setReport([]);
      setInvoice([]);
      if (reportRef.current) reportRef.current.value = "";
      if (invoiceRef.current) invoiceRef.current.value = "";
    }
  };

  return (
    <Card
      _hover={bgItem}
      bg="transparent"
      boxShadow="unset"
      px="24px"
      py="21px"
      transition="0.2s linear"
    >
      <Flex direction="row" align="center" justifyContent="space-between">
        <Link
          href={testProduct.image_link}
          isExternal
          position="relative"
          me="15px"
        >
          <Image
            src={testProduct.image_link}
            w="80px"
            me="16px"
            objectFit="cover"
          />
          <Button
            position="absolute"
            bg="transparent"
            p="0px !important"
            top="-7px"
            right="0px"
            borderRadius="50%"
          >
            <Text color={textColor} fontSize="30px">
              {testProduct.status === "TD" ? (
                <Badge variant="solid" colorScheme="red">
                  Taken Down
                </Badge>
              ) : testProduct.status === "R" ? (
                <Badge variant="subtle" colorScheme="red">
                  Reported
                </Badge>
              ) : testProduct.status === "S" ? (
                <Badge variant="subtle" colorScheme="yellow">
                  Suspicious
                </Badge>
              ) : testProduct.status === "W" ? (
                <Badge variant="subtle" colorScheme="green">
                  WhiteList
                </Badge>
              ) : (
                <Badge variant="subtle" colorScheme="yellow">
                  <Icon color="gold" as={MdBlockFlipped} />
                </Badge>
              )}
            </Text>
          </Button>
        </Link>

        {/* Info Section */}
        <Flex w="80%" direction="column">
          <Flex
            direction="column"
            w={{ base: "70%", md: "100%" }}
            me={{ base: "4px", md: "32px", xl: "10px", "3xl": "32px" }}
          >
            <Text
              color={textColor}
              fontSize={{
                base: "md",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              {index + 1}.&nbsp;&nbsp;
              <Link
                href={testProduct.prod_link}
                textDecoration="underline"
                isExternal
              >
                {testProduct.title}
              </Link>
            </Text>
          </Flex>
          <Flex direction="row">
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              {testProduct.keyword}
              <Image
                src={getPlatformIcon(Number(testProduct.platform_id))}
                width="15px"
              />
            </Text>
          </Flex>

          <Flex direction="row">
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              Product Code
            </Text>
            <Text
              color={textColor}
              fontSize={{
                base: "sm",
              }}
              fontWeight="bold"
            >
              {testProduct.prod_code}
            </Text>
            <Tooltip label={hasCopied ? "Copied!" : "Copy to Clipboard"}>
              <IconButton
                aria-label="Copy to Clipboard"
                icon={<MdContentCopy />}
                onClick={onCopy}
                variant="ghost"
                colorScheme={hasCopied ? "green" : "gray"}
                height="17px"
              />
            </Tooltip>
          </Flex>

          <Flex direction="row">
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              Seller Name:
            </Text>
            <Text
              color={textColor}
              fontSize={{
                base: "sm",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              {testProduct.seller_name}
            </Text>
          </Flex>
          <Flex direction="row">
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              MRP :
            </Text>
            <Text
              color={textColor}
              fontSize={{
                base: "sm",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              Rs. {testProduct.mrp}
            </Text>
          </Flex>
          <Flex direction="row">
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              Selling Price:
            </Text>
            <Text
              color={textColor}
              fontSize={{
                base: "sm",
              }}
              fontWeight="semibold"
              mb="5px"
              me="14px"
            >
              Rs. {testProduct.selling_price}
            </Text>
          </Flex>
          <Flex direction="row">
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              Manufacturer:
            </Text>
            <Text
              color={textColor}
              fontSize={{
                base: "sm",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              {testProduct.manufacturer}
            </Text>
          </Flex>

          <Flex>
            <Text
              color="secondaryGray.600"
              fontSize={{
                base: "sm",
              }}
              fontWeight="400"
              me="14px"
            >
              Test Purchase Status:{" "}
            </Text>
            <Text
              color={textColor}
              fontSize={{
                base: "sm",
              }}
              mb="5px"
              fontWeight="bold"
              me="14px"
            >
              {testProduct.test_purchase_status}
            </Text>
          </Flex>
        </Flex>

        <Flex gap="3" direction="column" w="20%" alignItems="flex-end">
          {report ? (
            <>
              <ButtonGroup isAttached variant="outline">
                <Menu>
                  <MenuButton
                    as={Button}
                    rightIcon={<MdOutlineKeyboardArrowDown />}
                  >
                    View Report
                  </MenuButton>

                  <MenuList>
                    {report.split(",").map((file, idx) => {
                      const fileName = file.replace(/["[\]]/g, "");
                      return (
                        <MenuItem>
                          <Button
                            alignSelf="right"
                            onClick={() =>
                              window.open(
                                `${process.env.REACT_APP_AZURE_URL}/${fileName}`,
                                "_blank"
                              )
                            }
                          >
                            {fileName}
                          </Button>
                        </MenuItem>
                      );
                    })}
                  </MenuList>
                </Menu>
                <IconButton
                  aria-label="Edit Report"
                  icon={<MdEdit />}
                  onClick={() => handleButtonClick("report")}
                />
                <Input
                  type="file"
                  accept="application/pdf"
                  name="report"
                  onChange={handleFileChange}
                  borderRadius="16px"
                  ref={reportRef}
                  display="none"
                  multiple
                />
              </ButtonGroup>
              {uploadReport.length > 0 && (
                <ol>
                  {uploadReport.map((file, idx) => (
                    <li key={idx}>{file.name}</li>
                  ))}
                </ol>
              )}
            </>
          ) : (
            isAdmin && (
              <>
              <Flex direction="column">
                <InputGroup>
                  <Button
                    variant="action"
                    alignSelf="right"
                    onClick={() => handleButtonClick("report")}
                  >
                    Upload Report
                  </Button>
                  <Input
                    type="file"
                    accept="application/pdf"
                    name="report"
                    onChange={handleFileChange}
                    borderRadius="16px"
                    ref={reportRef}
                    display="none"
                    multiple
                  />
                </InputGroup>
                {uploadReport.length > 0 && (
                  <ol>
                    {uploadReport.map((file, idx) => (
                      <li key={idx}>{file.name}</li>
                    ))}
                  </ol>
                )}
              </Flex>
            </>)
          )}

          {invoice ? (
            <>
              <ButtonGroup isAttached variant="outline">
                <Button
                  alignSelf="right"
                  onClick={() =>
                    window.open(
                      `${process.env.REACT_APP_AZURE_URL}/${invoice}`,
                      "_blank"
                    )
                  }
                >
                  View Invoice
                </Button>
                <IconButton
                  aria-label="Edit Invoice"
                  icon={<MdEdit />}
                  onClick={() => handleButtonClick("invoice")}
                />
                <Input
                  type="file"
                  accept="application/pdf"
                  name="invoice"
                  onChange={handleFileChange}
                  borderRadius="16px"
                  ref={invoiceRef}
                  display="none"
                />
              </ButtonGroup>
              {uploadInvoice?.name}
            </>
          ) : (
           isAdmin && (
            <>
              <Flex direction="column">
                <InputGroup>
                  <Button
                    variant="action"
                    alignSelf="right"
                    onClick={() => handleButtonClick("invoice")}
                  >
                    Upload Invoice
                  </Button>
                  <Input
                    type="file"
                    accept="application/pdf"
                    name="invoice"
                    onChange={handleFileChange}
                    borderRadius="16px"
                    ref={invoiceRef}
                    display="none"
                  />
                </InputGroup>
                {uploadInvoice?.name}
              </Flex>
            </>)
          )}

          {showSubmit ? (
            <Button
              variant="brand"
              alignSelf="right"
              isLoading={submitting}
              onClick={handleSubmit}
            >
              Upload File(s)
            </Button>
          ) : (
            <></>
          )}
        </Flex>
      </Flex>
    </Card>
  );
}
